import { MultiWithModal } from "components/FormControls/MultiWithModal";
import { RequiredFieldLabel } from "components/FormControls/RequiredFieldLabel";
import { useMessage } from "hooks/intl";

interface Props {
  fieldName: string;
}

export const LabelsArrayConditionValue = ({ fieldName }: Props) => {
  const { message } = useMessage();

  return (
    <MultiWithModal
      maxWidth="unset"
      data-test-id="condition-value"
      formField={fieldName}
      label={<RequiredFieldLabel text={message({ id: "value" })} />}
      placeholder={message({ id: "addCustomAttribute" })}
      maxLength={255}
    />
  );
};
